module.exports = __webpack_public_path__ + "static/media/lineworks_icon.0aa27b00.svg";